/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as R from 'ramda';
import { DTL_DATA_SERVICE } from '../constant';
import { fetchWithAuth } from '../helper/makeAjaxRequest';

const [PENDING, FULLFILLED, REJECTED] = ['pending', 'fulfilled', 'rejected'];
export const initialState = {
  data: [],
  loading: false,
  error: false,
  status: false
};

// selector
export const siteBrowserLovSelector = (state) => state?.siteBrowserLov?.data;
export const siteBrowserLovIsLoadedSelector = (state) =>
  state?.siteBrowserLov?.status === FULLFILLED;
export function sdBProtocolLovSelector(state) {
  const data = state?.siteBrowserLov?.data || [];
  return R.compose(
    R.sortBy(R.prop('label')),
    R.map((protocolNumber) => ({
      label: protocolNumber,
      value: protocolNumber
    })),
    R.uniq(),
    R.map((l) => l.protocolNumber)
  )(data);
}
export function sdBSiteLovSelector(state) {
  const data = state?.siteBrowserLov?.data || [];
  return R.compose(
    R.sortBy(R.prop('label')),
    R.map((site) => ({ label: site, value: site })),
    R.uniq(),
    R.flatten(),
    R.map((x) => R.props(['siteCtepId'])(x))
  )(data);
}
export function sdBLPOLovSelector(state) {
  const data = state?.siteBrowserLov?.data || [];
  return R.compose(
    R.sortBy(R.prop('label')),
    R.map((lpo) => ({ label: lpo, value: lpo })),
    R.uniq(),
    R.flatten(),
    R.map((x) => R.props(['lpo'])(x))
  )(data);
}
//
// thunk middleware
export const fetchSiteBrowserLov = createAsyncThunk(
  'fetchSiteBrowserLov',
  async (userType, { rejectWithValue }) => {
    try {
      return await fetchWithAuth(
        `${DTL_DATA_SERVICE}/siterosters/protocols/${userType}`
      );
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const siteBrowserLov = createSlice({
  name: fetchSiteBrowserLov,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSiteBrowserLov.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.data = [];
      state.status = PENDING;
    });
    builder.addCase(fetchSiteBrowserLov.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = FULLFILLED;
    });
    builder.addCase(fetchSiteBrowserLov.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.status = REJECTED;
    });
  }
});

export default siteBrowserLov.reducer;
